const api_key = 'b605c9b5-2dc6-40ac-9c2e-282f478df71e';
export async function yandexMapSearch(search_string, bounds) {
    const clean_bounds = [
        [
            Math.min(bounds[0][0], bounds[1][0]), //x, долгота, левый край
            Math.min(bounds[0][1], bounds[1][1]), //y, широта, левый край
        ],
        [
            Math.max(bounds[0][0], bounds[1][0]), //x, долгота, правый край
            Math.max(bounds[0][1], bounds[1][1]), //y, широта, правый край
        ],
    ];
    const str_bounds = clean_bounds
        .map((pair) => pair.map((num) => num.toFixed(6)).join(','))
        .join('~');
    let response, json;
    try {
        response = await fetch(`https://geocode-maps.yandex.ru/1.x/?apikey=${api_key}&geocode=${search_string}&lang=ru_RU&bbox=${str_bounds}&results=1&format=json`);
        json = (await response.json());
    }
    catch (error) {
        throw { json: null, response, error };
    }
    const member = json.response?.GeoObjectCollection?.featureMember?.[0];
    if (member == null) {
        throw { json, response };
    }
    const object = member.GeoObject;
    return {
        name: object.name,
        description: object.description,
        // @ts-ignore
        loc: object.Point.pos.split(' ').map(parseFloat),
    };
}
